<li class="flex align-items-center gap-2 py-1" [class.text-emerald-600]="isSuccess" [class.text-slate-800]="!isSuccess">
  <i *ngIf="isSuccess" class="text-base font-bold" [ngClass]="iconSuccess"></i>
  <i *ngIf="!isSuccess" [ngClass]="iconDefault" class="text-2xs"></i>
  <ng-content></ng-content>
</li>
